export default __webpack_public_path__ + "static/media/auggy_tile-mobile.png.webp";